import React from 'react';

export const Logo: React.FC<{ className?: string; size?: number }> = ({ className = "", size = 40 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background Circle with Gradient */}
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ea580c" />
          <stop offset="100%" stopColor="#c2410c" />
        </linearGradient>
      </defs>
      
      <circle cx="50" cy="50" r="48" fill="white" stroke="url(#logoGradient)" strokeWidth="4" />
      
      {/* Stylized Book/Education Icon */}
      <path 
        d="M30 40C30 34.4772 34.4772 30 40 30H70V70H40C34.4772 70 30 65.5228 30 60V40Z" 
        fill="#ea580c" 
        fillOpacity="0.1" 
      />
      <path 
        d="M35 35H65V65H35V35Z" 
        stroke="#ea580c" 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round" 
      />
      <path 
        d="M35 45H65M35 55H55" 
        stroke="#ea580c" 
        strokeWidth="3" 
        strokeLinecap="round" 
      />
      
      {/* Graduation Cap Top */}
      <path 
        d="M50 20L80 35L50 50L20 35L50 20Z" 
        fill="#1e293b" 
      />
      <path 
        d="M35 42V50C35 50 40 55 50 55C60 55 65 50 65 50V42" 
        stroke="#1e293b" 
        strokeWidth="3" 
        strokeLinecap="round" 
      />
      
      {/* Tassel */}
      <path 
        d="M80 35V55" 
        stroke="#ea580c" 
        strokeWidth="2" 
        strokeLinecap="round" 
      />
      <circle cx="80" cy="55" r="3" fill="#ea580c" />
      
      {/* BR Text */}
      <text 
        x="50" 
        y="85" 
        textAnchor="middle" 
        fill="#1e293b" 
        style={{ fontSize: '18px', fontWeight: '900', fontFamily: 'sans-serif' }}
      >
        BR
      </text>
    </svg>
  );
};
